import { Listbox } from '@headlessui/react';
import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { createPost } from '../../../../features/post/post.slice';
import ImageUpload from './ImageUpload';
import DateTimePicker from 'react-datetime-picker';
import Spinner from '../../../utilities/Spinner';

const AddPost = () => {
  const socialMedia = ['Instagram', 'Twitter', 'Facebook'];
  const options = ['Instant Post', 'Schedule Post'];
  const [postType, setPostType] = useState(options[0]);
  const handlePostType = (e) => {
    setPostType(e.target.value);
  };
  const [image, setImage] = useState(null);

  const [checked, setChecked] = useState([]);
  const [content, setContent] = useState('');
  const [brand, setBrand] = useState('');

  const handleChange = (e) => {
    const currentChecked = [...checked];
    if (e.target.checked) {
      setChecked([...currentChecked, e.target.value]);
    } else {
      setChecked(currentChecked.filter((item) => item !== e.target.value));
    }
  };

  const [dateTime, setDateTime] = useState(new Date());

  const dispatch = useDispatch();
  const submitData = () => {
    if (
      checked.length === 0 ||
      content.length === 0 ||
      brand.length === 0 ||
      image === null
    ) {
      toast.error('Please fill all the fields!');
      return;
    }
    const data = {
      Platform: checked,
      Content: content,
      Brand: brand,
      mypic: image,
      [postType === 'Schedule Post' && 'Date']: dateTime,
      postType,
    };
    dispatch(createPost(data));
  };

  const { loading } = useSelector((state) => state.post);

  return (
    <div className="flex flex-col h-full justify-center items-center bg-lightblue space-y-4">
      <h1 className="text-2xl font-semibold">Create a new post</h1>
      <div className="w-1/3 space-y-3">
        <select onChange={handlePostType} className="w-full p-2">
          <option>Please select post type</option>
          {options.map((option, index) => {
            return <option key={index}>{option}</option>;
          })}
        </select>
        {postType === 'Schedule Post' && (
          <DateTimePicker onChange={setDateTime} value={dateTime} />
        )}
        <textarea
          className="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
          placeholder="Enter your content here..."
          rows={5}
          onChange={(e) => setContent(e.target.value)}
          required
        />
        <input
          className="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
          placeholder="Brand"
          onChange={(e) => setBrand(e.target.value)}
        />
        <div>
          {socialMedia.map((el) => (
            <>
              <div className="flex space-x-2 items-center">
                <input
                  name={el}
                  value={el}
                  type="checkbox"
                  onChange={handleChange}
                />
                <label>{el}</label>
              </div>
            </>
          ))}
        </div>
        <ImageUpload setImage={setImage} />
        <button
          className={`text-white   focus:ring-4 ${
            loading ? 'bg-blue-300' : 'bg-darkblue hover:bg-blue-800'
          } focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-2 text-center self-center mt-5 flex justify-center`}
          onClick={submitData}
          disabled={loading}
        >
          {loading ? <Spinner sm={true} /> : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default AddPost;
